import { Pipe, PipeTransform } from '@angular/core';
import { roundToTwoDecimals } from '@wilson/utils';

@Pipe({
  name: 'prettyNumber',
})
export class PrettyNumberPipe implements PipeTransform {
  transform(value: number): string {
    const rounded = roundToTwoDecimals(value);
    if (Number.isInteger(rounded)) {
      return rounded.toString();
    } else {
      return rounded.toFixed(2);
    }
  }
}
